import { resourceAutoLogout, resourceMariAuditTrail } from '../../api/resources';
import store from '../../store';
import { getCookie, removeCookie } from '../../cookies';
import { AUTH_COOKIE, SESSION_ID_COOKIE } from '../../constants';

const storage = window.localStorage;
const location = window.location;
const eventTypes = ['mousemove', 'keydown', 'scroll', 'resize'];
let intervalId = null;
const CHECK_INACTIVITY_INTERVAL_SEC = 20;
const DEFAULT_TIMEOUT = 30;

let isPerformed = false;

/**
 * Sets in storage current time and resets isPerformed property
 */
let reSetTimeout = () => {
    isPerformed = false;
    storage.setItem('ms', Date.now());
};

/**
 * What needs to execute in some time
 * @param callback
 * @param ms
 */
let executor = (callback, ms) => {
    let timeoutEnabled =
        storage.getItem('timeoutEnabled') !== null ? storage.getItem('timeoutEnabled') : 'true';
    if (timeoutEnabled !== 'true') {
        storage.setItem('ms', Date.now());
    }
    let isLoading = store.state.isLoading;
    if (!storage.getItem('ms') || isLoading) {
        storage.setItem('ms', Date.now());
    }

    let storedMs = storage.getItem('ms');
    if (!isLoading && !isPerformed && (!storedMs || Date.now() - storedMs >= ms)) {
        if (location.hash === '#/dashboard' && store.state.expandedWidgetId) {
            removeCookie(AUTH_COOKIE);
            if (getCookie(SESSION_ID_COOKIE)) {
                resourceMariAuditTrail({
                    method: 'post',
                    data: JSON.stringify({
                        action: 'logout',
                        session_id: getCookie(SESSION_ID_COOKIE),
                    }),
                })
                    .then(() => {
                        removeCookie(SESSION_ID_COOKIE);
                    })
                    .catch(() => {});
                removeCookie(SESSION_ID_COOKIE);
            }
            callback.setNotification();
        } else {
            callback.timeoutCallback(callback.setNotification);
        }
        isPerformed = true;
    }
};

const timeout = {
    bind(el, binding, vnode) {
        return resourceAutoLogout()
            .then(({ data }) => data.minutes)
            .catch(() => DEFAULT_TIMEOUT)
            .then(minutes => {
                let min = Number.isInteger(parseInt(minutes)) ? parseInt(minutes) : DEFAULT_TIMEOUT;
                vnode.context.setTimeout(min);
                let ms = min * 60 * 1000;
                intervalId = setInterval(
                    executor.bind(null, binding.value, ms),
                    CHECK_INACTIVITY_INTERVAL_SEC * 1000
                );
                reSetTimeout();
                eventTypes.forEach(eventType => {
                    el.addEventListener(eventType, reSetTimeout, true);
                });
            });
    },
    update(el, binding) {
        if (binding.value.time !== binding.oldValue.time) {
            let min = Number.isInteger(parseInt(binding.value.time))
                ? parseInt(binding.value.time)
                : DEFAULT_TIMEOUT;
            let ms = min * 60 * 1000;
            clearInterval(intervalId);
            intervalId = setInterval(
                executor.bind(null, binding.value, ms),
                CHECK_INACTIVITY_INTERVAL_SEC * 1000
            );
        }
    },
    unbind(el) {
        eventTypes.forEach(eventType => {
            el.removeEventListener(eventType, reSetTimeout, true);
        });
        clearInterval(intervalId);
    },
};

export default timeout;

export function setTimeoutEnabled() {
    storage.setItem('timeoutEnabled', true);
}

export function setTimeoutDisabled() {
    storage.setItem('timeoutEnabled', false);
}
